import { useUser } from "hooks/use-user";
import PanicAlertJobCards from "./panic-alert-job-card";
import DefaultJobCards from "./default-job-card";

export default function JobCards() {
  const user = useUser();
  if (user.Roles.includes("CS Monitoring")) {
    return <PanicAlertJobCards />;
  }
  return <DefaultJobCards />;
}
